import { mapGetters } from 'vuex';
import { changeSkin } from '@/utils/common.js';
import Service from '@/service/index.js';

export default {
  data() {
    return {
      search: '',
      imgSrc: '',
      titleText: '',
      logoDefault: false,
      logoChange: false,
      pathList: [],
      logoText: ''
    };
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo',
      'getTenantParams'
    ])
  },
  created() {
    this.logoText = this.getTenantParams.title;
    this.logoImage = this.getTenantParams.logoImage;
    this.getCityName();
  },
  methods: {
    changeSkin,
    publishProject () {
      if (this.isSignin) {
        // 交易方式 1公开交易 2协议交易
        this.$store.commit('SET_TRADE_TYPE', 1);
        window.open(window.location.origin + '/#/publish-project/publisher-info');
      } else {
        this.$router.push('/signin');
      }
    },
    publishPurchase () {
      if (this.isSignin) {
        window.open(window.location.origin + '/#/publish-purchase/publisher-info');
      } else {
        this.$router.push('/signin');
      }
    },
    goHomepage() {
      this.$router.push('/index');
    },
    getCityName() {
      // let quan ='http://yongjixian.jlncjy.cn/';
      // portal.jieshou.chanquan.cacfintech.com
      // changchunshi.jlncjy.com
      // jlncjy.com
      // jlncjy.cn
      let origin = window.location.origin;
      let domainName;
      if(origin.split('//')[1].split('.')[0] === 'www') {
        domainName = origin.split('//')[1].split('.')[1];
      } else {
        domainName = origin.split('//')[1].split('.')[0];
        if(domainName.includes('localhost')) {
          domainName = 'localhost';
        }
      }
      Service.selectSiteInfoByDomain(domainName).then(res => {
        if (res && res.code === '0') {
          this.titleText = res.data.domainName;
          this.pathList = res.data.pathList;
          localStorage.setItem('level', res.data.level || '');
          localStorage.setItem('areaCode', res.data.areaCode || '');
          if(res.data.domainName) {
            this.logoChange = true;
          } else {
            this.logoDefault = true;
          }
          if(res.data.pathList) {
            localStorage.setItem('pathList', JSON.stringify(this.pathList));
          } else {
            localStorage.setItem('pathList', []);
          }
        }
      }).catch(() => {});
    }
  }
};
